import { recordTrack, trackStandardEvent } from '@saucelabs/sl-util-segmentio';
import { Key } from 'react';

import { ImageType } from './constants';

export enum VisualTrackingEvent {
  BuildClicked = 'Build Clicked',
  SnapshotReviewed = 'Snapshot Reviewed',
  ResultsSorted = 'Results Sorted',
  ObjectClicked = 'Object Clicked',
}

export const PRODUCT_AREA = 'Visual';

/**
 * Wrapper for recordTrack to automatically validate Visual event actions & append our product_area.
 * @param event
 * @param additionalData
 */
export const recordVisualTrack = (
  event: VisualTrackingEvent, additionalData: Record<string, string | number> = {},
) => recordTrack(event, {
  product_area: PRODUCT_AREA,
  ...additionalData,
});

export enum SnapshotAction {
  Approve = 'Approve',
  Reject = 'Reject',
  Unapprove = 'Unapprove',
}

export enum SortAction {
  Chronological = 'Chronological order',
  ChangedFirst = 'Changed first',
}

/**
 * Fire a pre-approved tracking event for the Visual area.
 */
export const track = {
  snapshotReviewed: (action: SnapshotAction) => (
    recordVisualTrack(VisualTrackingEvent.SnapshotReviewed, {
      action,
    })
  ),
  buildClicked: () => recordVisualTrack(VisualTrackingEvent.BuildClicked),
  resultsSorted: (sort: SortAction) => (
    recordVisualTrack(VisualTrackingEvent.ResultsSorted, {
      sort,
    })
  ),
  // eslint-disable-next-line camelcase
  filterClicked: (other: { filter_type: string, filter_value?: Key | Key[] }) => (
    trackStandardEvent(
      VisualTrackingEvent.ObjectClicked,
      PRODUCT_AREA,
      'Builds',
      'Select filter',
      {
        ...other,
      },
    )
  ),
  // eslint-disable-next-line camelcase
  downloadClicked: (other: { resource_type: ImageType, resource_id: string }) => (
    trackStandardEvent(
      VisualTrackingEvent.ObjectClicked,
      PRODUCT_AREA,
      'Diff',
      'Download image',
      {
        ...other,
      },
    )
  ),
};
